import Client from "..";
import { BankruptcyEffect } from "../inventory/Effects";
import { WheelSection } from "../wheel/WheelSection";
import {
  ActionTrigger,
  LevelAction,
  LevelActionWithWeight,
} from "./TimelineTypes";

function getRandomSection(): WheelSection | undefined {
  const sections = Client.state.currentLevelHistory;
  if (sections.length === 0) return undefined;
  const randomIndex = Math.floor(Math.random() * sections.length);
  return sections[randomIndex];
}

/* LevelAction modifiers */
export class LevelActionWeightedActions extends LevelAction {
  constructor(
    triggerType: ActionTrigger,
    public readonly levelActionsWithWeights: LevelActionWithWeight[],
  ) {
    super(triggerType);
  }

  Run() {
    const totalWeight = this.levelActionsWithWeights.reduce(
      (sum, action) => sum + action.weight,
      0,
    );
    const randomValue = Math.random() * totalWeight;

    let cumulativeWeight = 0;
    for (const action of this.levelActionsWithWeights) {
      cumulativeWeight += action.weight;
      if (randomValue < cumulativeWeight) {
        action.action.Run();
        break;
      }
    }
  }
}

export class LevelActionProbabilityAction extends LevelAction {
  constructor(
    triggerType: ActionTrigger,
    public readonly action: LevelAction,
    public readonly probability: number,
  ) {
    super(triggerType);
  }

  Run() {
    if (Math.random() < this.probability) {
      this.action.Run();
    }
  }
}

/* LevelActions */
export class LevelActionSubstractSectionScore extends LevelAction {
  constructor(
    triggerType: ActionTrigger,
    readonly maxAmount: number,
    public readonly randomAmount: boolean = false,
    public readonly randomSection: boolean = false,
  ) {
    super(triggerType);
  }

  Run() {
    let amount;
    if (this.randomAmount) {
      amount = Math.ceil(Math.random() * this.maxAmount);
    } else {
      amount = this.maxAmount;
    }

    let section;
    if (this.randomSection) {
      section = getRandomSection();
    } else {
      section = Client.state.lastScoredSection;
    }

    if (section) {
      section.score = section.score - amount;
    }
  }
}

export class LevelActionAddBankrupcy extends LevelAction {
  constructor(
    triggerType: ActionTrigger,
    public readonly duration: number = 1,
    public readonly randomSection: boolean = false,
  ) {
    super(triggerType);
  }

  Run() {
    let section;
    if (this.randomSection) {
      section = getRandomSection();
    } else {
      section = Client.state.lastScoredSection;
    }

    if (section) {
      section.effects.push(new BankruptcyEffect());
    }
  }
}

export class LevelActionDestroySection extends LevelAction {
  constructor(
    triggerType: ActionTrigger,
    public readonly randomSection: boolean = false,
  ) {
    super(triggerType);
  }

  Run() {
    let section;
    if (this.randomSection) {
      section = getRandomSection();
    } else {
      section = Client.state.lastScoredSection;
    }

    if (section) {
      const sectionIndex = section.wheel.sections.indexOf(section);
      if (sectionIndex !== -1) section.wheel.removeSection(sectionIndex);
    }
  }
}
